import { render, staticRenderFns } from "./supply-list.vue?vue&type=template&id=24776e3e&scoped=true&"
import script from "./supply-list.vue?vue&type=script&lang=js&"
export * from "./supply-list.vue?vue&type=script&lang=js&"
import style0 from "./supply-list.vue?vue&type=style&index=0&id=24776e3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24776e3e",
  null
  
)

export default component.exports